import { useState } from "react";
import { ICountDown, IRenderer } from "./ICountDown";
import Countdown from "react-countdown";
import React from "react";
export default function CountDown({ countDownValue, resendOtp }: ICountDown) {
  const [timer, setTimer] = useState<number>(Date.now() + countDownValue);
  function handleOnChildClick() {
    setTimer(Date.now() + countDownValue);
    resendOtp();
  }
  const renderer = ({ hours, minutes, seconds, completed }: IRenderer) => {
    if (completed) {
      return (
        <b
          style={{
            color: "#1778FB",
            textAlign: "center",
            cursor: "pointer",
            display: "inline-block",
          }}
          className="text-center text-xs mTop10"
          onClick={handleOnChildClick}
        >
          ارسال مجدد
        </b>
      );
    } else {
      // Render a countdown
      return (
        <p className="text-center yekanBakhFaNum mTop10">
          {(minutes < 10 ? "0" : "") + minutes}:
          {(seconds < 10 ? "0" : "") + seconds}
        </p>
      );
    }
  };
  return <Countdown overtime={true} date={timer} renderer={renderer} />;
}
